module.exports = __webpack_public_path__ + "static/banner-four-main-img-6ade92c3d5c70b3c70c3d9908255842d.png";